export { default as Address } from './address/Address'
export { default as CompanyName } from './company-name/CompanyName'
export { default as CompanyNumber } from './company-number/CompanyNumber'
export { default as EAN } from './ean/EAN'
export { default as Email } from './email/Email'
export { default as FirstName } from './first-name/FirstName'
export { default as Iban } from './iban/Iban'
export { default as LastName } from './last-name/LastName'
export { default as MeterNumber } from './meter-number/MeterNumber'
export { default as MeterReading } from './meter-reading/MeterReading'
export { default as Phone } from './phone/Phone'
export { default as PostalCodeAndTown } from './address/postal-code-and-town/PostalCodeAndTown'
